/**
 * WordPress dependencies
 */
import {
  useBlockProps,
  InnerBlocks,
  InspectorControls,
} from '@wordpress/block-editor';
import { PanelBody, TextControl, ColorPalette } from '@wordpress/components';
import { _x } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';

const Edit = ({ attributes, setAttributes }) => {
  const blockProps = useBlockProps({ className: 'card-item' });
  const { headingText, headingColor, textColor } = attributes;

  const colors = useSelect((select) => {
    return select('core/block-editor').getSettings().colors;
  }, []);

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={_x('Heading Options', 'admin panel title', 'vtx')}>
          <>
            <TextControl
              label={_x('Heading Text', 'admin panel label', 'vtx')}
              value={headingText}
              onChange={(value) => setAttributes({ headingText: value })}
            />
            <p className="theme-block__label">
              {_x('Heading background color', 'admin block label', 'vtx')}
            </p>
            <ColorPalette
              title="Heading background color"
              colors={colors}
              value={headingColor}
              onChange={(color) => setAttributes({ headingColor: color })}
              disableCustomColors={true} // Disable custom color picker
            />
            <p className="theme-block__label">
              {_x('Heading text color', 'admin block label', 'vtx')}
            </p>
            <ColorPalette
              title="Heading text color"
              colors={colors}
              value={textColor}
              onChange={(color) => setAttributes({ textColor: color })}
              disableCustomColors={true} // Disable custom color picker
            />
          </>
        </PanelBody>
      </InspectorControls>
      <div
        className={'card-item__title-wrapper'}
        style={{ backgroundColor: headingColor }}
      >
        <p className="theme-block__label">
          {_x('Cards item', 'admin block label', 'vtx')}
        </p>
        <p style={{ color: textColor }}>{headingText}</p>
      </div>
      <InnerBlocks
        allowedBlocks={[
          'core/paragraph',
          'core/heading',
          'core/list',
          'core/buttons',
        ]}
      />
    </div>
  );
};

export default Edit;
